import React from 'react';
import {
  CELL_EXPAND_DETAILS_PROPS
} from './Types';
import CellAbstract from './CellAbstract';
import { PuzzleButton } from '../../index';
import _ from 'lodash';

class CellExpandDetails extends CellAbstract<CELL_EXPAND_DETAILS_PROPS> {
  /**
   * Expands or collapses subItems
   */
  toggleExpandCollapse = () => {
    let { dataItem, onExpandDetailButtonChange } = this.props;
    dataItem = {
      ...dataItem,
      expanded: !dataItem.expanded
    };
    if (onExpandDetailButtonChange) {
      onExpandDetailButtonChange(dataItem);
    }
  };

  render() {
    const {
      dataItem,
      columnDataIndex,
      hasExpandDetailButton
    } = this.props;
    const { expanded } = dataItem;
    const foundLocale = hasExpandDetailButton(dataItem, columnDataIndex);
    if (_.isEmpty(foundLocale)) {
      return (
        <td className='tp-sub-level-cell-content'>
          &nbsp;
        </td>
      );
    }
    return this.renderCell(
      <PuzzleButton
        size={'small'}
        onClick={this.toggleExpandCollapse}
        className='tp-expand-collapse-cell k-button-flat'
        iconClass={expanded ? 'tp-icon tp-arrow-chevron-down' : 'tp-icon tp-arrow-chevron-right'}
      />
      , expanded ? this.translate('expandCollapseToggleButtonTooltip.collapsed') : this.translate('expandCollapseToggleButtonTooltip.expanded'));
  }
}

export default CellExpandDetails;
